import { makeCommunicationActionCreators } from 'shared/helpers/redux';
import * as A from '../types/actions';

export const { execute: downloadFile, completed: downloadFileSuccess, failed: downloadFileFail } =
  makeCommunicationActionCreators<A.DownloadFile, A.DownloadFileSuccess, A.DownloadFileFail>(
    'FILE_DOWNLOADING_SERVICE:DOWNLOAD', 'FILE_DOWNLOADING_SERVICE:DOWNLOAD_SUCCESS', 'FILE_DOWNLOADING_SERVICE:DOWNLOAD_FAIL',
  );
